import './index.less';

import { HOMEPAGE_TAB_SECTIONS, SECTION_TABS } from '@/shared/constants/homepage-constants';
import { HomepagePlatformSection, SectionTabType } from '@/shared/types/homepage';
import React, { useRef, useState } from 'react';

import BrandGrid from '@/components/Home/HomepageV2/BrandGrid';
import FAQContainer from '@/components/Common/FAQContainer';
import HomePageIntro from '@/components/Home/HomepageV4/Intro';
import { SEO_HOMEPAGE } from '@/shared/constants/seo';
import Script from 'next/script';
import SectionTabs from '@/components/Home/HomepageV2/Tabs';
import StartNow from '@/components/Home/HomepageV2/StartNow';
import SupplierProfileSection from '@/components/Home/HomepageV2/SupplierProfileSection';
import TabSection from '@/components/Home/HomepageV2/TabSection';
import { faqJsonLd } from '@/shared/seo/jsonld';
import { map } from 'lodash-es';

const HomepageV4 = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [selectedAnchor, setSelectedAnchor] = useState<string>(SECTION_TABS[0].anchor);

  const handleClickTab = (tab: SectionTabType) => {
    setSelectedAnchor(tab.anchor);
  };

  return (
    <div className="pietra-home-page-v3">
      <HomePageIntro />
      <div className="pietra-home-page-v3-content">
        <div className="text-section-wrap">
          <div className="text-section-content">
            <div className="title">Your data has been talking. You just couldn't hear it.</div>
            <div className="description">
              Most brands are buried in data, starving for direction. Pietra agents monitor your ads, surface what's
              working, and build the assets to act on it so the only thing left for you is the call.
            </div>
          </div>
        </div>
        <SectionTabs tabs={SECTION_TABS} handleClickTab={handleClickTab} />
        <div id="homepage-tab-sections-anchor" className="homepage-tab-sections">
          {map(
            HOMEPAGE_TAB_SECTIONS.filter((section: HomepagePlatformSection) => section.anchor === selectedAnchor),
            (section: HomepagePlatformSection) => {
              return <TabSection key={section.id} section={section} />;
            },
          )}
        </div>
        <div ref={ref} className="homepage-bottom-content">
          <BrandGrid />
          <SupplierProfileSection />
          <FAQContainer faq={SEO_HOMEPAGE} />
          <Script
            id="faq-seo-homepage"
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(faqJsonLd(SEO_HOMEPAGE)),
            }}
          />
          <StartNow />
        </div>
      </div>
    </div>
  );
};

export default HomepageV4;
